import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const Salary = React.lazy(() => import("@/pages/salary/index"));
const Payslip = React.lazy(() => import("@/pages/salary/payslip/index"));
const Itdeclaration = React.lazy(() => import("@/pages/payroll/ITD/Index"));
const EmpFbp = React.lazy(() => import("@/pages/salary/FbpEmployee"));
const EmpFba = React.lazy(() => import("@/pages/salary/FbaEmployee"));
const Reimbursementclaims = React.lazy(() =>
  import("@/pages/salary/ReimbursementClaims")
);
const POI = React.lazy(() => import("@/pages/salary/proofOfInvestment/Index"));
const ContractTax = React.lazy(() => import("@/pages/salary/ContractTax"));

const Salarycomponent = [
  // {
  //     path: "salary",
  //     element: (
  //         <SuspenseWrapper>
  //             <Salary />
  //         </SuspenseWrapper>
  //     ),
  // },
  {
    path: "payslip",
    element: (
      <SuspenseWrapper>
        <Payslip />
      </SuspenseWrapper>
    ),
  },
  {
    path: "itDeclaration",
    element: (
      <SuspenseWrapper>
        <Itdeclaration />
      </SuspenseWrapper>
    ),
  },
  {
    path: "empFbp",
    element: (
      <SuspenseWrapper>
        <EmpFbp />
      </SuspenseWrapper>
    ),
  },
   {
    path: "empFba",
    element: (
      <SuspenseWrapper>
        <EmpFba />
      </SuspenseWrapper>
    ),
  },
  {
    path: "reimbursementClaims",
    element: (
      <SuspenseWrapper>
        <Reimbursementclaims />
      </SuspenseWrapper>
    ),
  },
  {
    path: "proofofinvestment",
    element: (
      <SuspenseWrapper>
        <POI />
      </SuspenseWrapper>
    ),
  },
  {
    path: "contractTax",
    element: (
      <SuspenseWrapper>
        <ContractTax />
      </SuspenseWrapper>
    ),
  },
];

export default Salarycomponent;
